/** @format */

import routes from '@/config/routes';

const dirs = {
  data() {
    return {
      //_dirs: {},
      __dirs: {},
      hasInitDir: false,
      dirs: {},
      dirs_: {},
    };
  },
  created() {
    this.__dirs = {};

    this.initDirs();
  },
  computed: {},
  methods: {
    initDirs() {
      if (this.hasInitDir) return;
      const model = [
        'job',
        'user',
        'client',
        'object',
        'office',
        'storage',
        'metro',
        'employee',
        'department',
        'investor',
        'category',
        'vendor',
        'service',
        'cashbox',
        'objectProps',
        'operationTable',
        'roles',
        'routes',
        'leadsGroup',
        'leadsTask',
        'adsSubAgent',
        'adsContact',
        'residential_complex',
        // 'good',
      ];

      if (!this.hasInitDir) {
        this.hasInitDir = true;
        for (let i = 0; i < model.length; i++) {
          let name = model[i];
          Object.defineProperty(this.dirs, name, {
            get: () => {
              return (this.$dir.get(name) || []).map((item) => ({ ...item }));
            },
          });
        }
      }
    },
  },
};

export default dirs;
